












import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
	components: {},
})
export default class Link extends Vue {
	@Prop() readonly to
}
